var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"filter-button",on:{"click":_vm.handleFilterClick}},[_c('img',{staticClass:"filter-icon",attrs:{"alt":"filter","src":_vm.filterIcon}}),_vm._v(" "),_c('span',{staticClass:"filter-text"},[_vm._v("Filtrar")])])
}
var staticRenderFns = []

export { render, staticRenderFns }